export const svgAnimatedBackground = `<?xml version="1.0" encoding="utf-8"?> 
    <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1920 960" style="enable-background:new 0 0 1920 960;" xml:space="preserve"> 
    <style type="text/css"> 
     .st0{fill:#F5F8FF;} 
     .st1{opacity:0.4;clip-path:url(#SVGID_2_);} 
     .st2{fill:#81ABEE;} 
     .st3{fill:#3D75E4;display:none} 
     .st4{fill:url(#SVGID_3_);display:none} 
     .st5{fill:url(#SVGID_4_);display:none} 
     .st6{fill:url(#SVGID_5_);} 
     .st7{fill:url(#SVGID_6_);} 
     .st8{fill:#E0EAFB;} 
     .st9{fill:#C0D6F6;} 
     .st10{fill:#E4EDFB;} 
     .st11{fill:url(#SVGID_7_);}
     .st12{opacity:0.6;} 
     .st13{fill:#A8C5F5;} 
     .st14{opacity:0.5;fill:url(#SVGID_8_);enable-background:new;} 
     .st15{fill:#CDDFFE;} 
     .st16{opacity:0.2;fill:#81ABEE;enable-background:new;} 
     .st17{fill:url(#SVGID_9_);} 
     .st18{fill:#C7D9F8;} 
     .st19{opacity:0.5;fill:#F6F9FE;enable-background:new;} 
     .st20{fill:url(#SVGID_10_);} 
     .st21{fill:url(#SVGID_11_);} 
     .st22{fill:#CEDEF9;} 
     .st23{fill:none;stroke:url(#SVGID_12_);stroke-width:14;stroke-miterlimit:10;} 
     .st24{fill:none;stroke:url(#SVGID_13_);stroke-width:14;stroke-miterlimit:10;} 
     .st25{fill:none;stroke:url(#SVGID_14_);stroke-width:14;stroke-miterlimit:10;} 
     .st26{fill:none;stroke:url(#SVGID_15_);stroke-width:14;stroke-miterlimit:10;} 
     .st27{fill:none;stroke:url(#SVGID_16_);stroke-width:14;stroke-miterlimit:10;} 
     .st28{fill:none;stroke:#C0D6F6;stroke-width:14.5;stroke-miterlimit:10;} 
     .st29{fill:none;stroke:#A3BFEF;stroke-width:14.5;stroke-miterlimit:10;} 
     .st30{fill:none;stroke:url(#main-pipe_1_);stroke-width:101;} 
     .st31{fill:none;stroke:#F7CFD5;stroke-width:20;stroke-miterlimit:10;} 
     .st32{fill:#F196A5;} 
     .st33{fill:none;stroke:#F196A5;stroke-width:20;stroke-miterlimit:10;} 
     .st34{fill:#FBE9EC;} 
     .st35{fill:#F7CFD5;} 
     .st36{fill:url(#SVGID_17_);} 
     .st37{fill:url(#SVGID_18_);} 
     .st38{fill:#FED2D9;} 
     .st39{fill:#FF9EAE;} 
     .st40{fill:#96BAF8;} 
     .st41{fill:#FFF7F8;} 
     .st42{fill:#E5EEFF;} 
     .st43{fill:url(#SVGID_19_);} 
     .st44{fill:url(#SVGID_20_);}
     #main-pipe_1_1{stop-color: #81ABEE; transition: all 3s;}
     #drain-pipes{opacity: 0; transition: opacity 4s;}
     .animate{transition: transform 4s;} 
     .animate-rotation{transform-box: fill-box; transform-origin: center;} 
     .animate-active .move-l{transform: translate(-90px, 0);} 
     .animate-active .move-r{transform: translate(90px, 0);} 
     .animate-active .move-r2{transform: translate(140px, 0);} 
     .animate-active .move-up{transform: translate(0, -50px);} 
     .animate-active .rotate{transform: rotate(360deg)} 
     .animate-active #drain-pipes{opacity: 1} 
     .animate-active #main-pipe_1_1{stop-color: #C0D6F6} 
    </style> 
    <rect class="st0" width="1920" height="960"/> 
    <g> 
     <defs> 
      <rect id="SVGID_1_" width="1920" height="960"/> 
     </defs> 
     <clipPath id="SVGID_2_"> 
      <use xlink:href="#SVGID_1_"  style="overflow:visible;"/> 
     </clipPath> 
     <g class="st1"> 
      <g id="fabric"> 
       <path class="st2" d="M1920,755h-707v300h707V755z"/> 
       <path class="st3" d="M1630.1,864.6c19.4,0,35.1-15.7,35.1-35.1c0-19.4-15.7-35.1-35.1-35.1c-19.4,0-35.1,15.7-35.1,35.1 
        C1595,848.9,1610.7,864.6,1630.1,864.6z"/> 
        
        <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="1630.1051" y1="118.5" x2="1630.1051" y2="52" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#81ABEE"/> 
        <stop  offset="1" style="stop-color:#E4EDFB"/> 
       </linearGradient> 
       <path class="st4" d="M1657.5,851.3h-54.9V934h54.9V851.3z"/> 
       <path class="st3" d="M1503.1,864.6c19.4,0,35.1-15.7,35.1-35.1c0-19.4-15.7-35.1-35.1-35.1c-19.4,0-35.1,15.7-35.1,35.1 
        C1468,848.9,1483.7,864.6,1503.1,864.6z"/> 
        
        <linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="1503.1051" y1="118.5" x2="1503.1051" y2="52" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#81ABEE"/> 
        <stop  offset="1" style="stop-color:#E4EDFB"/> 
       </linearGradient> 
       <path class="st5" d="M1530.5,851.3h-54.9V934h54.9V851.3z"/> 
        
        <linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="1459" y1="439.5001" x2="2141.0015" y2="439.5001" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#E4EDFB"/> 
        <stop  offset="0.7521" style="stop-color:#FFFFFF"/> 
       </linearGradient> 
       <path class="st6" d="M1459,450.2c0-164.4,167.2-74.5,311.9-127.6c155.7-57.1,83.6,88.9,260,22.4c159.7-60.2,166,387-118.4,387 
        C1476.6,732,1459,641.2,1459,450.2z"/> 
        
        <linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="1342.5" y1="346.945" x2="1716.0601" y2="346.945" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0.4062" style="stop-color:#E4EDFB"/> 
        <stop  offset="1" style="stop-color:#81ABEE"/> 
       </linearGradient> 
       <path class="st7" d="M1599.1,449.9h-139.6c0,32.8-21,230.4-117,326.3c117,0,256.6,0,373.6,0 
        C1620.1,680.3,1599.1,482.7,1599.1,449.9z"/> 
       <path class="st8" d="M1714.5,513.6h-112.3c0,26.4-16.9,185.4-94.2,262.6c94.2,0,206.5,0,300.6,0 
        C1731.4,699,1714.5,540,1714.5,513.6z"/> 
       <path class="st9" d="M1706,650.6l71.5-45.2v45.2l71.8-45.4v45.4l70.8-44.6v171.4h-214V650.6z"/> 
       <path class="st10" d="M1880.3,677.4c-4.3,0-7.7,3.5-7.7,7.7v26.9h15.5v-26.9C1888.1,680.9,1884.6,677.4,1880.3,677.4z"/> 
       <path class="st10" d="M1846.7,677.4c-4.3,0-7.7,3.5-7.7,7.7v26.9h15.5v-26.9C1854.4,680.9,1850.9,677.4,1846.7,677.4z"/> 
       <path class="st10" d="M1813,677.4c-4.3,0-7.7,3.5-7.7,7.7v26.9h15.5v-26.9C1820.7,680.9,1817.3,677.4,1813,677.4z"/> 
       <path class="st10" d="M1779.3,677.4c-4.3,0-7.7,3.5-7.7,7.7v26.9h15.5v-26.9C1787.1,680.9,1783.6,677.4,1779.3,677.4z"/> 
       <path class="st10" d="M1745.7,677.4c-4.3,0-7.7,3.5-7.7,7.7v26.9h15.5v-26.9C1753.4,680.9,1749.9,677.4,1745.7,677.4z"/> 
       <path class="st10" d="M1880.3,733.1c-4.3,0-7.7,3.5-7.7,7.7v26.9h15.5v-26.9C1888.1,736.6,1884.6,733.1,1880.3,733.1z"/> 
       <path class="st10" d="M1846.7,733.1c-4.3,0-7.7,3.5-7.7,7.7v26.9h15.5v-26.9C1854.4,736.6,1850.9,733.1,1846.7,733.1z"/> 
       <path class="st10" d="M1813,733.1c-4.3,0-7.7,3.5-7.7,7.7v26.9h15.5v-26.9C1820.7,736.6,1817.3,733.1,1813,733.1z"/> 
       <path class="st10" d="M1779.3,733.1c-4.3,0-7.7,3.5-7.7,7.7v26.9h15.5v-26.9C1787.1,736.6,1783.6,733.1,1779.3,733.1z"/> 
       <path class="st10" d="M1745.7,733.1c-4.3,0-7.7,3.5-7.7,7.7v26.9h15.5v-26.9C1753.4,736.6,1749.9,733.1,1745.7,733.1z"/> 
        
        <linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="1286" y1="315" x2="1476" y2="315" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#81ABEE"/> 
        <stop  offset="1" style="stop-color:#E4EDFB"/> 
       </linearGradient> 
       <path class="st11" d="M1476,514h-190v262h190V514z"/> 
       <g class="st12"> 
        <path class="st2" d="M1476,514h-154v19h154V514z"/> 
        <path class="st2" d="M1476,625h-154v19h154V625z"/> 
        <path class="st2" d="M1476,699h-154v19h154V699z"/> 
        <path class="st2" d="M1476,662h-154v19h154V662z"/> 
        <path class="st2" d="M1476,736h-154v19h154V736z"/> 
        <path class="st2" d="M1476,551h-154v19h154V551z"/> 
        <path class="st2" d="M1476,588h-154v19h154V588z"/> 
       </g> 
       <path class="st13" d="M1476,755h-263v21h263V755z"/> 
       <path class="st2" d="M1542,593h-85v183h85V593z"/> 
        
        <linearGradient id="SVGID_8_" gradientUnits="userSpaceOnUse" x1="1457" y1="231.5" x2="1542" y2="231.5" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#81ABEE"/> 
        <stop  offset="1" style="stop-color:#E4EDFB"/> 
       </linearGradient> 
       <path class="st14" d="M1457,681h85v95h-85V681z"/> 
       <path class="st9" d="M1706,599h-62v177.2h62V599z"/> 
       <path class="st2" d="M1644,599c0-17.1,13.9-31,31-31s31,13.9,31,31H1644z"/> 
       <path class="st2" d="M1681.1,650.3h-10.7v126h10.7V650.3z"/> 
       <path class="st15" d="M1715,506h-112v8h112V506z"/> 
       <path class="st16" d="M1476,533h-154v18h154V533z"/> 
       <path class="st16" d="M1476,607h-154v18h154V607z"/> 
       <path class="st16" d="M1476,681h-154v18h154V681z"/> 
       <path class="st16" d="M1476,644h-154v18h154V644z"/> 
       <path class="st16" d="M1476,718h-154v18h154V718z"/> 
       <path class="st16" d="M1476,570h-154v18h154V570z"/> 
        
        <linearGradient id="SVGID_9_" gradientUnits="userSpaceOnUse" x1="1457" y1="231.5" x2="1542" y2="231.5" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#81ABEE"/> 
        <stop  offset="1" style="stop-color:#E4EDFB"/> 
       </linearGradient> 
       <path class="st17" d="M1457.1,681l-0.1,95l85-95H1457.1z"/> 
       <path class="st2" d="M1670.4,650.3c0-3,2.4-5.4,5.4-5.4s5.3,2.4,5.3,5.4H1670.4z"/> 
       <path class="st15" d="M1706,599h-62v7.5h62V599z"/> 
       <path class="st18" d="M1599,442h-139v8h139V442z"/> 
      </g> 
      <g id="mountains"> 
       <path class="st10" d="M-240,933.8l352.3-691.5l554.1,691.5H-240z"/> 
       <path class="st9" d="M112.3,242.4L-10.3,933.8H-240L112.3,242.4z"/> 
       <path class="st19" d="M2.3,458.4c27.5-26.5,71.4-116.1,137.1-55.3c26.8,24.8,38.1-31.5,45.2-70.5c-24.7-30.8-72.2-90.1-72.2-90.1 
        L2.3,458.4z"/> 
       <path class="st10" d="M23.1,933.8l282.9-555.2L751,933.8H23.1z"/> 
       <path class="st9" d="M306.1,378.6l-98.5,555.2H23.1L306.1,378.6z"/> 
       <path class="st19" d="M217.7,552.1c22.1-21.3,57.4-93.2,110.1-44.4c21.6,19.9,30.6-25.3,36.3-56.6c-19.8-24.7-58-72.4-58-72.4 
        L217.7,552.1z"/> 
      </g> 
      <g id="wave-back" class="animate move-r"> 
        
        <linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="2608.99" y1="50.5002" x2="-450.1499" y2="50.5002" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#E4EDFB"/> 
        <stop  offset="1" style="stop-color:#81ABEE"/> 
       </linearGradient> 
       <path class="st20" d="M1105.8,943v-44c0-5.9-2.6-11.8-7.8-16.3c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0v0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-5.2,4.5-7.8,10.4-7.8,16.3v44 
        H1105.8z"/> 
        
        <linearGradient id="SVGID_11_" gradientUnits="userSpaceOnUse" x1="2609" y1="50.5002" x2="-450.1399" y2="50.5002" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#E4EDFB"/> 
        <stop  offset="1" style="stop-color:#81ABEE"/> 
       </linearGradient> 
       <path class="st21" d="M2609,943v-44c0-5.9-2.6-11.8-7.8-16.3c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0v0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-5.2,4.5-7.8,10.4-7.8,16.3v44H2609z"/> 
      </g> 
      <g id="sub-fabric" style="display: none"> 
       <path class="st22" d="M1657.5,851.3h-54.9V934h54.9V851.3z"/> 
       <path class="st22" d="M1530.5,851.3h-54.9V934h54.9V851.3z"/> 
      </g> 
      <g id="pipes-1"> 
        
        <linearGradient id="SVGID_12_" gradientUnits="userSpaceOnUse" x1="544.976" y1="487.9497" x2="673.269" y2="487.9497" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#81ABEE"/> 
        <stop  offset="0.9999" style="stop-color:#D1C3DD"/> 
        <stop  offset="1" style="stop-color:#F7CFD5"/> 
       </linearGradient> 
       <path class="st23" d="M666.3,268.2v347.7v21.5v5.4c0,1.2-0.1,2.4-0.1,3.6c-0.5,4.8-2.3,9.4-5.3,13.1c-1.6,1.8-3.2,3.6-5.2,4.9 
        c-2,1.3-4.1,2.5-6.3,3.3c-2.3,0.8-4.6,1.3-7,1.3c-1.2,0.1-2.4,0-3.6,0.1h-7.9H529.5"/> 
        
        <linearGradient id="SVGID_13_" gradientUnits="userSpaceOnUse" x1="544.98" y1="473.49" x2="702.1982" y2="473.49" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#81ABEE"/> 
        <stop  offset="0.9999" style="stop-color:#D1C3DD"/> 
        <stop  offset="1" style="stop-color:#F7CFD5"/> 
       </linearGradient> 
       <path class="st24" d="M695.2,268.2v347.7v21.5v8c0,2.4-0.1,4.8-0.2,7.2c-0.6,4.7-1.6,9.4-3.4,13.9c-1.9,4.4-4.1,8.6-7.2,12.3 
        c-5.9,7.5-14,13.3-23,16.4c-4.5,1.5-9.2,2.5-14,2.7c-2.4,0.2-4.8,0.1-7.2,0.1h-9.3H545"/> 
        
        <linearGradient id="SVGID_14_" gradientUnits="userSpaceOnUse" x1="544.96" y1="459.025" x2="731.1169" y2="459.025" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#81ABEE"/> 
        <stop  offset="0.9999" style="stop-color:#D1C3DD"/> 
        <stop  offset="1" style="stop-color:#F7CFD5"/> 
       </linearGradient> 
       <path class="st25" d="M724.1,268.2v347.7v21.5c0,7.2,0.2,14.3-0.4,21.5c-0.2,1.8-0.5,3.5-0.8,5.3l-0.4,2.7l-0.7,2.6 
        c-0.5,1.7-0.8,3.5-1.4,5.2l-1.8,5c-0.3,0.8-0.6,1.7-1,2.5l-1.2,2.4c-0.8,1.6-1.5,3.2-2.5,4.7c-0.9,1.5-1.8,3.1-2.8,4.6l-3.2,4.3 
        c-8.9,11.2-21,19.9-34.5,24.5c-0.8,0.3-1.7,0.7-2.5,0.9l-2.6,0.7c-1.7,0.4-3.4,1-5.2,1.2l-5.3,0.8c-1.8,0.3-3.6,0.2-5.3,0.4 
        c-3.6,0.3-7.2,0.2-10.7,0.2h-10.7H545"/> 
        
        <linearGradient id="SVGID_15_" gradientUnits="userSpaceOnUse" x1="544.97" y1="444.565" x2="760.0334" y2="444.565" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#81ABEE"/> 
        <stop  offset="0.9999" style="stop-color:#D1C3DD"/> 
        <stop  offset="1" style="stop-color:#F7CFD5"/> 
       </linearGradient> 
       <path class="st26" d="M753,268.2v347.7v21.5v6.3c0,2.4,0,4.8-0.1,7.2c0,4.8-0.5,9.5-0.9,14.2c-0.3,2.3-0.8,4.7-1.2,7l-0.7,3.5 
        l-1,3.4c-0.7,2.3-1.2,4.6-2,6.8l-2.6,6.6c-0.4,1.1-0.9,2.2-1.4,3.2l-1.6,3.2c-1,2.1-2.1,4.2-3.4,6.2c-1.2,2-2.5,4-3.8,6l-4.2,5.6 
        c-11.7,14.7-27.6,26.2-45.3,32.7c-8.9,3.2-18.2,5.4-27.6,6c-4.7,0.5-9.5,0.5-14.2,0.5h-12.2H545"/> 
        
        <linearGradient id="SVGID_16_" gradientUnits="userSpaceOnUse" x1="544.976" y1="430.12" x2="788.96" y2="430.12" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#81ABEE"/> 
        <stop  offset="0.9999" style="stop-color:#D1C3DD"/> 
        <stop  offset="1" style="stop-color:#F7CFD5"/> 
       </linearGradient> 
       <path class="st27" d="M782,268.2v347.7v21.5v7.2c0,3,0,6-0.1,8.9c0,6-0.8,11.8-1.4,17.7c-0.5,2.9-1.1,5.8-1.6,8.7l-0.9,4.3 
        l-1.2,4.2c-0.9,2.8-1.6,5.6-2.7,8.4c-1.1,2.7-2.2,5.5-3.3,8.2c-0.5,1.4-1.1,2.7-1.8,4l-2,3.9c-1.3,2.6-2.7,5.2-4.3,7.7 
        c-1.5,2.5-3.1,5-4.7,7.4c-1.7,2.3-3.5,4.7-5.3,7c-14.6,18.2-34.1,32.5-56,40.8c-11,4.1-22.5,7.1-34.2,8 
        c-5.9,0.7-11.8,0.9-17.8,0.9h-13.6h-98.4"/> 
      </g> 
      <g id="pipes-2"> 
       <path class="st28" d="M1018.2,309.4v191.5" style="display: none"/> 
       <path class="st28" d="M989.2,309.4v191.5" style="display: none"/> 
       <path class="st28" d="M960.2,309.4v191.5" style="display: none"/> 
       <path class="st28" d="M931.2,309.4v191.5" style="display: none"/> 
       <path class="st28" d="M902.2,309.4v191.5" style="display: none"/> 
       <path class="st28" d="M1018.2,500.9v47.9v23.9v6l0,1.3c0,0.4,0,0.8,0,1.1c0.1,0.7,0.1,1.5,0.2,2.2c0,0.7,0.2,1.5,0.3,2.2 
        c0,0.4,0.2,0.7,0.2,1.1c0.1,0.4,0.1,0.7,0.2,1.1c0.2,0.7,0.4,1.4,0.6,2.1c0.4,1.4,1.1,2.7,1.6,4c1.3,2.6,2.9,5.1,4.9,7.4 
        c1.9,2.3,4.2,4.2,6.6,5.9c1.2,0.8,2.5,1.6,3.8,2.2c0.6,0.4,1.3,0.6,2,0.9l1,0.4c0.3,0.1,0.7,0.3,1,0.4"/> 
       <path class="st28" d="M989.2,500.9v47.9v23.9v6l0.1,2.2c0,0.7,0,1.4,0.1,2.1c0.1,1.4,0.2,2.7,0.4,4.1c0.1,1.4,0.4,2.7,0.6,4 
        c0.1,0.7,0.3,1.3,0.4,2c0.2,0.7,0.3,1.3,0.5,2c0.4,1.3,0.7,2.6,1.2,3.9c0.8,2.6,1.9,5.1,3.1,7.6c2.4,4.9,5.4,9.5,9,13.6 
        c3.5,4.2,7.7,7.8,12.2,10.9c2.3,1.5,4.6,3,7,4.2c1.2,0.7,2.5,1.1,3.7,1.7l1.9,0.8c0.6,0.3,1.3,0.5,1.9,0.7"/> 
       <path class="st29" d="M960.2,500.9v47.9v23.9v6c0.1,2,0.1,4,0.2,6c0.1,2,0.3,4,0.6,5.9c0.2,2,0.6,4,0.9,5.9c0.1,1,0.4,2,0.6,2.9 
        c0.2,1,0.4,2,0.7,2.9c0.6,1.9,1,3.8,1.7,5.7c1.2,3.8,2.8,7.5,4.5,11.1c3.5,7.1,7.9,13.9,13.2,19.9c5.2,6.1,11.2,11.4,17.8,15.9 
        c3.3,2.2,6.7,4.3,10.3,6.1c1.8,1,3.6,1.7,5.4,2.5c0.9,0.4,1.8,0.7,2.8,1.1c0.9,0.4,1.9,0.7,2.8,1"/> 
       <path class="st29" d="M931.2,500.9v47.9v23.9v6l0.1,3.8c0,1.3,0,2.6,0.2,3.9c0.2,2.6,0.4,5.2,0.7,7.8c0.3,2.6,0.8,5.2,1.2,7.8 
        c0.2,1.3,0.5,2.6,0.8,3.8c0.3,1.3,0.6,2.6,0.9,3.8c0.7,2.5,1.4,5.1,2.3,7.5c1.6,5,3.7,9.8,5.9,14.6c4.6,9.4,10.4,18.3,17.3,26.2 
        c6.8,8,14.8,14.9,23.4,20.9c4.4,2.9,8.8,5.7,13.6,8c2.3,1.2,4.7,2.2,7.1,3.3c1.2,0.5,2.4,1,3.7,1.5c1.2,0.5,2.5,1,3.7,1.4"/> 
       <path class="st29" d="M902.2,500.9v47.9v23.9v6l0.1,4.7c0,1.6,0.1,3.2,0.2,4.9c0.2,3.2,0.5,6.5,0.9,9.7c0.4,3.2,0.9,6.4,1.5,9.6 
        c0.3,1.6,0.7,3.2,1,4.8c0.4,1.6,0.7,3.2,1.2,4.8c0.9,3.1,1.7,6.3,2.8,9.4c2,6.2,4.6,12.2,7.4,18.1c5.8,11.7,12.9,22.7,21.5,32.5 
        c8.5,9.8,18.3,18.5,29,25.9c5.4,3.6,11,7,16.8,9.9c2.9,1.5,5.9,2.8,8.8,4.1c1.5,0.6,3,1.2,4.5,1.8c1.5,0.6,3,1.2,4.6,1.7"/> 
       <path class="st29" d="M1040.9,611c0.3,0.1,0.7,0.2,1,0.4l1.1,0.3c0.7,0.2,1.4,0.3,2.1,0.5c1.4,0.2,2.9,0.5,4.4,0.6 
        c0.7,0.1,1.5,0.1,2.2,0.1l0.3,0l0.2,0h0.4h1.5h3h12h47.9H1287"/> 
       <path class="st29" d="M1031.3,638.3l1.9,0.7c0.7,0.2,1.3,0.4,2,0.6c1.3,0.4,2.6,0.7,4,1c2.7,0.5,5.4,1,8.1,1.1 
        c1.4,0.1,2.7,0.2,4.1,0.2l0.5,0l0.3,0h0.4h1.5h3h12h47.9h169.6"/> 
       <path class="st29" d="M1021.7,665.7l2.8,1c1,0.3,1.9,0.5,2.9,0.8c1.9,0.6,3.9,1,5.8,1.4c3.9,0.8,7.9,1.4,11.8,1.7 
        c4,0.3,8,0.3,12,0.3h12h47.9h169.6"/> 
       <path class="st29" d="M1012.1,693.1l3.7,1.3c1.2,0.4,2.5,0.7,3.8,1.1c2.5,0.8,5.1,1.3,7.6,1.9c5.2,1,10.4,1.8,15.6,2.2 
        c2.6,0.2,5.2,0.3,7.8,0.3l1,0l0.8,0h1.5h3h12h47.9H1287"/> 
       <path class="st29" d="M1002.5,720.4l4.6,1.6c1.6,0.5,3.1,0.9,4.7,1.4c3.1,0.9,6.3,1.6,9.5,2.3c6.4,1.3,12.8,2.3,19.3,2.7 
        c3.2,0.3,6.5,0.4,9.7,0.4l2.2,0h1.5h3h12h47.9h169.6"/> 
      </g> 

      <g id="drain-pipes">
<g id="drain-pipe-2">
<path id="Vector_7" d="M1630.1 864.584C1649.49 864.584 1665.21 848.867 1665.21 829.48C1665.21 810.092 1649.49 794.375 1630.1 794.375C1610.72 794.375 1595 810.092 1595 829.48C1595 848.867 1610.72 864.584 1630.1 864.584Z" fill="#3D75E4"/>
<g id="Vector_8">
<path d="M1657.54 851.298H1602.67V934H1657.54V851.298Z" fill="#CEDEF9"/>
<path d="M1657.54 851.298H1602.67V934H1657.54V851.298Z" fill="url(#paint2_linear_3245_830)"/>
</g>
</g>
<g id="drain-pipe-1">
<path id="Vector_9" d="M1503.1 864.584C1522.49 864.584 1538.21 848.867 1538.21 829.48C1538.21 810.092 1522.49 794.375 1503.1 794.375C1483.72 794.375 1468 810.092 1468 829.48C1468 848.867 1483.72 864.584 1503.1 864.584Z" fill="#3D75E4"/>
<g id="Vector_10">
<path d="M1530.54 851.298H1475.67V934H1530.54V851.298Z" fill="#CEDEF9"/>
<path d="M1530.54 851.298H1475.67V934H1530.54V851.298Z" fill="url(#paint3_linear_3245_830)"/>
</g>
</g>
</g>

      <g id="main-pipe"> 
       <linearGradient id="main-pipe_1_" gradientUnits="userSpaceOnUse" x1="264" y1="230" x2="264" y2="91" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#81ABEE"/> 
        <stop id="main-pipe_1_1" offset="1"/> 
       </linearGradient> 
       <path id="main-pipe" class="st30" d="M381.5,730H292c-52.5,0-95,42.5-95,95v246"/> 
      </g> 
      <g id="wheel" class="animate animate-rotation rotate"> 
       <path class="st31" d="M462.6,641.3v174"/> 
       <path class="st31" d="M375.6,728.2h174"/> 
       <path class="st32" d="M462.6,703.3c-13.8,0-25,11.2-25,25s11.2,25,25,25c13.8,0,25-11.2,25-25S476.4,703.3,462.6,703.3z"/> 
       <path class="st33" d="M462.6,641.3c-48,0-87,38.9-87,87s38.9,87,87,87c48,0,87-38.9,87-87S510.6,641.3,462.6,641.3z"/> 
      </g> 
      <g id="clouds-1" class="animate move-l"> 
       <path class="st34" d="M678.4,349.5c0-70-56.8-126.8-126.8-126.8s-126.8,56.8-126.8,126.8H678.4z"/> 
       <path class="st35" d="M961.7,349.5c0-70-56.8-126.8-126.8-126.8S708,279.4,708,349.5H961.7z"/> 
        
        <linearGradient id="SVGID_17_" gradientUnits="userSpaceOnUse" x1="496.94" y1="692.775" x2="825.84" y2="692.775" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#FEF8F9"/> 
        <stop  offset="1" style="stop-color:#F7CFD5"/> 
       </linearGradient> 
       <path class="st36" d="M825.8,349.5c0-90.8-73.6-164.5-164.5-164.5s-164.5,73.6-164.5,164.5H825.8z"/> 
      </g> 
      <g id="clouds-2" class="animate move-r"> 
       <path class="st10" d="M1121.1,381.4c0-95.8,77.7-173.4,173.4-173.4c95.8,0,173.4,77.6,173.4,173.4H1121.1z"/> 
        
        <linearGradient id="SVGID_18_" gradientUnits="userSpaceOnUse" x1="1211.39" y1="647.66" x2="937.412" y2="647.66" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#F6F9FE"/> 
        <stop  offset="1" style="stop-color:#C0D6F6"/> 
       </linearGradient> 
       <path class="st37" d="M932.5,381.4c0-76.3,61.9-138.2,138.2-138.2c76.3,0,138.2,61.9,138.2,138.2H932.5z"/> 
       <path class="st9" d="M1155.4,381.4c0-56.1,45.5-101.6,101.6-101.6s101.6,45.5,101.6,101.6H1155.4z"/> 
      </g> 
      <g id="vertical-circles" class="animate move-up"> 
       <path class="st38" d="M1399.5,217.6c4.1,0,7.5-3.3,7.5-7.3c0-4-3.3-7.3-7.5-7.3s-7.5,3.3-7.5,7.3 
        C1392,214.3,1395.3,217.6,1399.5,217.6z"/> 
       <path class="st38" d="M1420.1,217.6c4.1,0,7.5-3.3,7.5-7.3c0-4-3.4-7.3-7.5-7.3c-4.1,0-7.5,3.3-7.5,7.3 
        C1412.6,214.3,1415.9,217.6,1420.1,217.6z"/> 
       <path class="st38" d="M1399.5,243.2c4.1,0,7.5-3.3,7.5-7.3c0-4-3.3-7.3-7.5-7.3s-7.5,3.3-7.5,7.3 
        C1392,239.9,1395.3,243.2,1399.5,243.2z"/> 
       <path class="st39" d="M1399.5,268.7c4.1,0,7.5-3.3,7.5-7.3c0-4-3.3-7.3-7.5-7.3s-7.5,3.3-7.5,7.3 
        C1392,265.4,1395.3,268.7,1399.5,268.7z"/> 
       <path class="st39" d="M1420.1,268.7c4.1,0,7.5-3.3,7.5-7.3c0-4-3.4-7.3-7.5-7.3c-4.1,0-7.5,3.3-7.5,7.3 
        C1412.6,265.4,1415.9,268.7,1420.1,268.7z"/> 
       <path class="st38" d="M1420.1,294.3c4.1,0,7.5-3.3,7.5-7.3c0-4-3.4-7.3-7.5-7.3c-4.1,0-7.5,3.3-7.5,7.3 
        C1412.6,291,1415.9,294.3,1420.1,294.3z"/> 
       <path class="st40" d="M1399.5,319.8c4.1,0,7.5-3.3,7.5-7.3c0-4-3.3-7.3-7.5-7.3s-7.5,3.3-7.5,7.3 
        C1392,316.5,1395.3,319.8,1399.5,319.8z"/> 
       <path class="st40" d="M1420.1,319.8c4.1,0,7.5-3.3,7.5-7.3c0-4-3.4-7.3-7.5-7.3c-4.1,0-7.5,3.3-7.5,7.3 
        C1412.6,316.5,1415.9,319.8,1420.1,319.8z"/> 
       <path class="st40" d="M1420.1,345.4c4.1,0,7.5-3.3,7.5-7.3c0-4-3.4-7.3-7.5-7.3c-4.1,0-7.5,3.3-7.5,7.3 
        C1412.6,342.1,1415.9,345.4,1420.1,345.4z"/> 
       <path class="st38" d="M1420.1,370.9c4.1,0,7.5-3.3,7.5-7.3c0-4-3.4-7.3-7.5-7.3c-4.1,0-7.5,3.3-7.5,7.3 
        C1412.6,367.6,1415.9,370.9,1420.1,370.9z"/> 
       <path class="st40" d="M1399.5,396.5c4.1,0,7.5-3.3,7.5-7.3c0-4-3.3-7.3-7.5-7.3s-7.5,3.3-7.5,7.3 
        C1392,393.2,1395.3,396.5,1399.5,396.5z"/> 
       <path class="st40" d="M1420.1,396.5c4.1,0,7.5-3.3,7.5-7.3c0-4-3.4-7.3-7.5-7.3c-4.1,0-7.5,3.3-7.5,7.3 
        C1412.6,393.2,1415.9,396.5,1420.1,396.5z"/> 
       <path class="st39" d="M1420.1,422c4.1,0,7.5-3.3,7.5-7.3c0-4-3.4-7.3-7.5-7.3c-4.1,0-7.5,3.3-7.5,7.3 
        C1412.6,418.8,1415.9,422,1420.1,422z"/> 
       <path class="st39" d="M1420.1,448.1c4.1,0,7.5-3.3,7.5-7.3c0-4-3.4-7.3-7.5-7.3c-4.1,0-7.5,3.3-7.5,7.3 
        C1412.6,444.9,1415.9,448.1,1420.1,448.1z"/> 
      </g> 
      <g id="horizontal-circles" class="animate move-r2"> 
       <path class="st40" d="M495.5,230.3c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C488.8,227.3,491.8,230.3,495.5,230.3z"/> 
       <path class="st41" d="M476.9,230.3c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C470.2,227.3,473.2,230.3,476.9,230.3z"/> 
       <path class="st42" d="M458.3,230.3c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C451.6,227.3,454.6,230.3,458.3,230.3z"/> 
       <path class="st40" d="M421.2,230.3c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C414.4,227.3,417.4,230.3,421.2,230.3z"/> 
       <path class="st41" d="M402.5,230.3c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C395.8,227.3,398.8,230.3,402.5,230.3z"/> 
       <path class="st42" d="M383.9,230.3c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C377.2,227.3,380.2,230.3,383.9,230.3z"/> 
       <path class="st42" d="M365.4,230.3c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C358.6,227.3,361.6,230.3,365.4,230.3z"/> 
       <path class="st42" d="M346.8,230.3c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C340,227.3,343,230.3,346.8,230.3z"/> 
       <path class="st38" d="M625.7,207.2c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C618.9,204.2,622,207.2,625.7,207.2z"/> 
       <path class="st38" d="M607.1,207.2c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6s-6.8,3-6.8,6.6C600.3,204.2,603.4,207.2,607.1,207.2 
        z"/> 
       <path class="st41" d="M588.5,207.2c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6s-6.8,3-6.8,6.6C581.8,204.2,584.8,207.2,588.5,207.2 
        z"/> 
       <path class="st38" d="M569.9,207.2c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6s-6.8,3-6.8,6.6C563.2,204.2,566.2,207.2,569.9,207.2 
        z"/> 
       <path class="st38" d="M551.3,207.2c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C544.6,204.2,547.6,207.2,551.3,207.2z"/> 
       <path class="st40" d="M532.7,207.2c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6s-6.8,3-6.8,6.6C526,204.2,529,207.2,532.7,207.2z"/> 
       <path class="st42" d="M514.1,207.2c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C507.4,204.2,510.4,207.2,514.1,207.2z"/> 
       <path class="st41" d="M495.5,207.2c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C488.8,204.2,491.8,207.2,495.5,207.2z"/> 
       <path class="st38" d="M476.9,207.2c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C470.2,204.2,473.2,207.2,476.9,207.2z"/> 
       <path class="st42" d="M421.2,207.2c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C414.4,204.2,417.4,207.2,421.2,207.2z"/> 
       <path class="st41" d="M383.9,207.2c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C377.2,204.2,380.2,207.2,383.9,207.2z"/> 
       <path class="st41" d="M365.4,207.2c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C358.6,204.2,361.6,207.2,365.4,207.2z"/> 
       <path class="st38" d="M346.8,207.2c3.7,0,6.8-3,6.8-6.6c0-3.6-3-6.6-6.8-6.6c-3.7,0-6.8,3-6.8,6.6 
        C340,204.2,343,207.2,346.8,207.2z"/> 
      </g> 
      <g id="wave-front" class="animate move-l"> 
        
        <linearGradient id="SVGID_19_" gradientUnits="userSpaceOnUse" x1="2369.99" y1="25.5002" x2="-690.1501" y2="25.5002" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#81ABEE"/> 
        <stop  offset="1" style="stop-color:#E4EDFB"/> 
       </linearGradient> 
       <path class="st43" d="M865.9,968v-44c0-5.9-2.6-11.8-7.8-16.3c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0v0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-5.2,4.5-7.8,10.4-7.8,16.3v44H865.9 
        z"/> 
        
        <linearGradient id="SVGID_20_" gradientUnits="userSpaceOnUse" x1="2370" y1="25.5002" x2="-690.1401" y2="25.5002" gradientTransform="matrix(1 0 0 -1 0 960)"> 
        <stop  offset="0" style="stop-color:#81ABEE"/> 
        <stop  offset="1" style="stop-color:#E4EDFB"/> 
       </linearGradient> 
       <path class="st44" d="M2370,968v-44c0-5.9-2.6-11.8-7.8-16.3c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0v0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0 
        c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0 
        c-10.4-9-27.2-9-37.6,0c-10.4,9-27.2,9-37.6,0c-10.4-9-27.2-9-37.6,0c-5.2,4.5-7.8,10.4-7.8,16.3v44H2370z"/> 
      </g> 
     </g> 
    </g> 
    </svg>`;
